import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateToTodayTime, formatSupport } from "../../../common/common";
import { setCurrentAnalysisData as setParentCurrentAnalysisData } from "../../../../store";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";

const AnalysisDetailsHistory = ({
  order_details_id,
  isSingleOrderExclude,
  setIsSingleOrderExclude,
  setAnalysisId,
  loadingAnalysisResults,
  analysesId,
  setCurrentAnalysisData,
  analysisDetailsHistoryOriginalData,
  setAnalysisDetailsHistoryOriginalData,
  analysisDetailsHistory,
  setAnalysisDetailsHistory,
  setSupportFilter,
  setShowLoadingPage,
  setSwitchTab,
  setMainCompleteAnalysisResult,
  setSupportFilteredAnalysisResult,
  setDisplayAnalysisResult,
  setProductsBundles,
  isDefault=false
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBySupport, setSortBySupport] = useState("");
  const [sortByItemSet, setSortByItemSet] = useState("");
  const [sortByDate, setSortByDate] = useState("");
  const [defaultAnalysisDetails, setDefaultAnalysisDetails] = useState({});

  const getAnlysisHistory = async () => {
    try {
      setShowLoadingPage(true);
      const response = await fetch(
        `${process.env.REACT_APP_FETCH_ANALYSIS_DETAILS_HISTORY}?order_details_id=${order_details_id}&isDefault=${isDefault}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const responseData = await response.json();
      if (!response.ok) {
        if (responseData?.detail?.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login");
        }
        throw new Error(
          responseData.detail?.message || "Failed to fetch analysis history"
        );
      }

      if (responseData) {
        const filtered = responseData.data
        .reverse()
        .filter((item) => {
          if (isDefault) {
            return true;
          }
          return item.isExclude === isSingleOrderExclude; // Return all items if isSingleOrderExclude is undefined or null
        });

        if (filtered.length > 0) {
          setAnalysisId(filtered[0]._id);
          setCurrentAnalysisData(filtered[0]);
          dispatch(setParentCurrentAnalysisData(filtered[0]));
          setSupportFilter(formatSupport(filtered[0].min_support));
        }else{
          setIsSingleOrderExclude(false)
        }
        setAnalysisDetailsHistory(filtered);
        setAnalysisDetailsHistoryOriginalData(responseData.data);
        
        
      }
    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setShowLoadingPage(false);
    }
  };



  const set_Default_analysis_Details = async (id, isDefault = true) => {
    try{
      let url = `${process.env.REACT_APP_API_END_POINT}/data-analysis/set-default-analysis-details`
      const response = await axios.put(url, null, {
        params: {
          analysis_details_id:id,
          isDeafult: isDefault,
          order_details_id: order_details_id
        }
      });
      setDefaultAnalysisDetails({
        [id]: isDefault
      })
      // toast.success('Default order updated successfully');
    }catch(error){
      toast.error('Failed to set default order');
    }
  };

  const applyFiltersAndSort = (isFetchData = "") => {
    let filtered = [...analysisDetailsHistoryOriginalData];

    // 1. Search filter
    if (searchQuery) {
      filtered = filtered.filter((item) =>
        item.analysisTitle?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // 2. Item Set filter
    switch (sortByItemSet) {
      case "1":
        filtered = filtered.filter((item) => item.itemset?.isSingle);
        break;
      case "2":
        filtered = filtered.filter((item) => item.itemset?.isPairs);
        break;
      case "3":
        filtered = filtered.filter((item) => item.itemset?.isTriples);
        break;
      case "4":
        filtered = filtered.filter((item) => item.itemset?.isQuadruples);
        break;
      case "all":
        break;
      default:
        // no filter
        break;
    }

    // 3. Sort by Support
    filtered.sort((a, b) => {
      const aSupport = Number(a.min_support);
      const bSupport = Number(b.min_support);
      if (sortBySupport === "asc") {
        return aSupport - bSupport;
      } else if (sortBySupport === "desc") {
        return bSupport - aSupport;
      }
      return 0;
    });

    // 4. Sort by Date
    filtered.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if (sortByDate === "newest") {
        return dateB - dateA;
      } else if (sortByDate === "oldest") {
        return dateA - dateB;
      }
      return 0;
    });

    // 5. isSingleOrderExclude
    filtered = filtered.filter(
      (item) => item.isExclude === isSingleOrderExclude
    );

    // start logic for on/off 1st show
    if (filtered.length > 0 && isFetchData) {
      setAnalysisId(filtered[0]?._id);
      setSwitchTab(1);
      setDisplayAnalysisResult([]);
      setSupportFilteredAnalysisResult([]);
      setMainCompleteAnalysisResult([]);
      setProductsBundles([]);
      // setSupportFilter(formatSupport(filtered[0]?.min_support));
      setSupportFilter(filtered[0]?.min_support*100);

      // console.log(formatSupport(filtered[0]?.min_support),"hhhhhhhhhhhhhhhhhhhhhh",filtered[0]?.min_support*100)
      setCurrentAnalysisData(filtered[0]);
      dispatch(setParentCurrentAnalysisData(filtered[0]));
    }else{
      if(!isDefault){
        setAnalysisId(null);
        setSwitchTab(1);
        setDisplayAnalysisResult([]);
        setSupportFilteredAnalysisResult([]);
        setMainCompleteAnalysisResult([]);
        setProductsBundles([]);
        setSupportFilter(0);
        setCurrentAnalysisData([]);
      }
    }
    // end logic for on/off 1st show
    setAnalysisDetailsHistory(filtered);
  };

  useEffect(() => {
    if (analysisDetailsHistoryOriginalData.length === 0) {
      getAnlysisHistory();
    }
  }, []);
  useEffect(() => {
    applyFiltersAndSort();
  }, [
    searchQuery,
    sortByItemSet,
    sortBySupport,
    sortByDate,
    // isSingleOrderExclude,
  ]);

  useEffect(() => {
    applyFiltersAndSort(true);
  }, [isSingleOrderExclude]);

  const design = (
    <>
      <aside className={`w-full md:w-[22%] border-r border-gray-200 sticky top-0 h-screen overflow-y-auto bg-white z-10  ${isDefault && 'hidden'}`}>
        <div className="p-0 pt-0 h-full flex flex-col">
          <div className="p-0 pt-0 h-full flex flex-col">
            <div className="mb-4 mt-0">
              {/* 🔍 Search Input */}
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search analyses..."
                  className="w-full pl-10 pr-4 py-2 border-b border-gray-300 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <i className="fas fa-search absolute left-4 top-3 text-gray-400"></i>
              </div>

              {/* 🔽 Sort Dropdowns */}
              <div className="flex flex-wrap gap-0">
                <div className="relative w-1/3">
                  <span className="absolute top-[50%] translate-y-[-50%] left-4 text-xs">
                    <i class="fa-solid fa-sort text-gray-500"></i>
                  </span>
                  <select
                    className="text-gray-400 appearance-none w-full border-b border-r bg-white border-gray-300 rounded-0 pl-7 px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:ring-0"
                    value={sortBySupport}
                    onChange={(e) => setSortBySupport(e.target.value)}
                  >
                    <option value="">Support</option>
                    <option value="asc">Low to High</option>
                    <option value="desc">High to Low</option>
                  </select>
                </div>

                <div className="relative w-1/3">
                  <span className="absolute top-[50%] translate-y-[-50%] left-4 text-xs">
                    <i class="fa-solid fa-sort text-gray-500"></i>
                  </span>
                  <select
                    className="text-gray-400 appearance-none w-full border-b border-r bg-white border-gray-300 rounded-0 pl-7 px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:ring-0"
                    value={sortByItemSet}
                    onChange={(e) => setSortByItemSet(e.target.value)}
                  >
                    <option value="">Itemset</option>
                    <option value="1">1 Itemset</option>
                    <option value="2">2 Itemset</option>
                    <option value="3">3 Itemset</option>
                    <option value="4">4 Itemset</option>
                    <option value="all">All Itemset</option>
                  </select>
                </div>

                <div className="relative w-1/3">
                  <span className="absolute top-[50%] translate-y-[-50%] left-4 text-xs">
                    <i class="fa-solid fa-sort text-gray-500"></i>
                  </span>
                  <select
                    className="text-gray-400 appearance-none w-full border-b bg-white border-gray-300 rounded-0 pl-7 px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:ring-0"
                    value={sortByDate}
                    onChange={(e) => setSortByDate(e.target.value)}
                  >
                    <option value="">Date</option>
                    <option value="newest">Newest First</option>
                    <option value="oldest">Oldest First</option>
                  </select>
                </div>

                <div className="w-full justify-between flex items-center space-x-3 px-4 mt-3">
                  <label className="text-sm text-gray-500">
                    Single Item Orders Excluded
                  </label>
                  <button
                    onClick={() => setIsSingleOrderExclude((prev) => !prev)}
                    className={`relative w-10 h-5 transition duration-300 ease-in-out rounded-full ${
                      isSingleOrderExclude ? "bg-indigo-600" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`absolute left-1 top-1 w-3 h-3 bg-white rounded-full shadow-md transform transition ${
                        isSingleOrderExclude ? "translate-x-5" : "translate-x-0"
                      }`}
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-grow overflow-y-auto custom-scrollbar border-t border-gray-200">
              {analysisDetailsHistory.length > 0 ? (
                analysisDetailsHistory.map((data, index) => {
                  const isActive = data._id === analysesId;
                  const isChecked = Object.keys(defaultAnalysisDetails).length === 0
                      ? data.isDefault // ⬅️ user updated value
                      : defaultAnalysisDetails[data._id] || false;
                  return (
                    <div
                      key={data._id}
                      className="history-card bg-white p-4 border-b border-gray-200 cursor-pointer"
                      onClick={() => {
                        if (isActive) return;
                        setAnalysisId(data._id);
                        setSwitchTab(1);
                        setDisplayAnalysisResult([]);
                        setSupportFilteredAnalysisResult([]);
                        setMainCompleteAnalysisResult([]);
                        setProductsBundles([]);
                        setSupportFilter(formatSupport(data.min_support));
                        setCurrentAnalysisData(data);
                        dispatch(setParentCurrentAnalysisData(data))
                      }}
                    >
                      <div className="flex justify-between items-start mb-2">
                        {!isActive ? (
                          <button
                            className="analysis-badge bg-indigo-100 text-indigo-800 rounded-full mr-2"
                            onClick={() => {
                              setAnalysisId(data._id);
                              setSwitchTab(1);
                              setDisplayAnalysisResult([]);
                              setSupportFilteredAnalysisResult([]);
                              setMainCompleteAnalysisResult([]);
                              setProductsBundles([]);
                              setSupportFilter(formatSupport(data.min_support));
                              setCurrentAnalysisData(data);
                              dispatch(setParentCurrentAnalysisData(data))
                            }}
                          >
                            View Now
                          </button>
                        ) : (
                          <span className="analysis-badge bg-green-100 text-green-800 rounded-full">
                            Currently Viewing
                          </span>
                        )}

                        {isActive && loadingAnalysisResults && (
                          <svg
                            className="animate-spin h-4 w-4 text-indigo-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v8H4z"
                            ></path>
                          </svg>
                        )}
                        <span className="text-xs text-gray-500">
                          {formatDateToTodayTime(data.createdAt)}
                        </span>
                      </div>

                      <h3 className="text-md font-medium text-gray-800 mb-1">
                        {data.analysisTitle || data.title}
                        <label className="mx-2 inline-flex items-center">
                              <input 
                                type="checkbox" 
                                checked={isChecked} 
                                readOnly 
                                className="accent-green-600 w-4 h-4 rounded" 
                                onClick={(e)=>{
                                  if(e.target.checked === false)
                                    return
                                  set_Default_analysis_Details(data._id,e.target.checked)
                                  
                                }}
                              />
                            </label>
                      </h3>

                      <div className="text-xs text-gray-600 mb-2">
                        <span className="text-xs text-gray-400">
                          {data.analysisNotes}
                        </span>
                      </div>

                      <div className="flex justify-between text-xs text-gray-500">
                        <span>
                          <i className="fas fa-user-circle mr-1"></i>
                          {(data.min_support * 100)}%
                        </span>
                        <span>
                          <i className="fas fa-database mr-1"></i>
                          {data.algorithm}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="flex flex-col items-center justify-center w-full py-10 text-center text-gray-500">
                  <i className="fas fa-box-open text-4xl mb-2 text-gray-400"></i>
                  <p className="text-lg font-semibold">No Record Found</p>
                  <p className="text-sm text-gray-400 mt-1">
                    We couldn't find any matching data.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </aside>
    </>
  );
  return design;
};

export default AnalysisDetailsHistory;
